import { render, staticRenderFns } from "./RoHButton.vue?vue&type=template&id=0e576e7c&scoped=true&"
import script from "./RoHButton.vue?vue&type=script&lang=js&"
export * from "./RoHButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e576e7c",
  null
  
)

export default component.exports